import { Badge } from '@mui/material';
import { IconType, Nullable } from 'common-types';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { BadgeStatusType } from '../../elements/BadgeIcon/badgeIcon.types';
import ConnectivityIcon from '../../elements/ConnectivityIcon/ConnectivityIcon';

const SupplyChainConnectorLogo: FC<SupplyChainConnectorLogoProps> = ({
  name,
  isBuiltIn,
  connectorIcon: ConnectorIcon,
  status,
}) => {
  const { classes } = useStyles();
  let content: Nullable<JSX.Element> = null;
  content = (
    <>
      {typeof ConnectorIcon === 'string' ? (
        <img
          src={ConnectorIcon}
          alt={name}
          style={{ height: 30, width: 'auto', maxWidth: '100%' }}
        />
      ) : (
        <ConnectorIcon
          style={{
            height: 30,
            width: 'auto',
            maxWidth: '100%',
          }}
        />
      )}
    </>
  );

  if (isBuiltIn) {
    content = (
      <Badge
        sx={{ flexShrink: 1 }}
        color='primary'
        variant='dot'
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}>
        <div className={classes.iconWrapper}>{content}</div>
      </Badge>
    );
  }

  return (
    <Badge
      sx={{ flexShrink: 1 }}
      badgeContent={<ConnectivityIcon type={status} />}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}>
      <div className={classes.iconWrapper}>{content}</div>
    </Badge>
  );
};

const useStyles = makeStyles()({
  iconWrapper: {
    display: 'flex',
  },
});

export interface SupplyChainConnectorLogoProps {
  name: string;
  connectorIcon: string | IconType;
  isBuiltIn: boolean;
  status: BadgeStatusType;
}

export default SupplyChainConnectorLogo;
